import ReactJson from '@microlink/react-json-view';
import { Modal, toast } from '@solinkcorp/solink-components';
import { withAspen } from 'components/aspen/withAspen';
import React from 'react';
import { JSONModalAspen } from './JSONModalAspen';
import {
  useJSONModalActions,
  type JSONCopyNotifier,
  type JSONModalProps,
} from './useJSONModalActions';

export { serializeDates } from './useJSONModalActions';

const classicNotifier: JSONCopyNotifier = {
  success: (message) => {
    toast.success(message);
  },
  error: (message) => {
    toast.error(message);
  },
};

export const JSONModal: React.FC<JSONModalProps> = (props) => {
  const { locale, serializedSrc, copyJSONToClipboard, title, closeModal } = useJSONModalActions(
    props,
    classicNotifier,
  );

  return (
    <Modal
      actions={[
        {
          isPrimary: false,
          text: locale.general.cancel,
          onClick: closeModal,
        },
        {
          isPrimary: true,
          text: 'Copy to Clipboard',
          onClick: copyJSONToClipboard,
        },
      ]}
      title={title}
      isOpen={props.isModalOpen}
      colorMode="dark"
      type="double-wide"
      onClose={closeModal}
    >
      <ReactJson
        src={serializedSrc}
        name={false}
        collapsed={1} // Collapse top-level objects by default
        enableClipboard={true}
        theme="tube"
        escapeStrings={false}
        displayDataTypes={false}
      />
    </Modal>
  );
};

export default withAspen(JSONModal, JSONModalAspen);
